import { render, staticRenderFns } from "./bullBreedWiseSemenStock.vue?vue&type=template&id=70c4e466&scoped=true&"
import script from "./bullBreedWiseSemenStock.vue?vue&type=script&lang=js&"
export * from "./bullBreedWiseSemenStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4e466",
  null
  
)

export default component.exports